const appConstants = {
    CustomerCommunityAppId:3,
    PartnerCommunityAppId:4,
    SupportSiteAppId:2,
    CustomercommunityAppName:"Customer Community/Support Site",
}

export default appConstants;